import { render, staticRenderFns } from "./PanelAnalista.vue?vue&type=template&id=9c6b90ca&scoped=true"
import script from "./PanelAnalista.vue?vue&type=script&lang=js"
export * from "./PanelAnalista.vue?vue&type=script&lang=js"
import style0 from "./PanelAnalista.vue?vue&type=style&index=0&id=9c6b90ca&prod&scoped=true&lang=css"
import style1 from "./PanelAnalista.vue?vue&type=style&index=1&id=9c6b90ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6b90ca",
  null
  
)

export default component.exports